<template>
  <PSRegisterUser />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
